// pages/Dashboard.js
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../context/UserContext'

import api from '../services/api'

function Dashboard() {
  const { userData } = useContext(UserContext)
  const navigate = useNavigate()
  const [info, setInfo] = useState(null)

  useEffect(() => {
    if (!userData) {
      console.log('⚠️ Not logged in')
      navigate('/login')
      return
    }
    loadData()
  }, [userData, navigate])

  const loadData = async () => {
    try {
      const res = await api.get('/user/me')
      setInfo(res.data)
      console.log('✅ Loaded profile:', res.data)
    } catch (err) {
      console.log('❌ Error loading profile:', err)
    }
  }

  return (
    <div>
      <h2>Dashboard</h2>
	  
      {info && (
        <div>
          <p>Name: {info.name}</p>
          <p>Surname: {info.surname}</p>
          <p>Email: {info.email}</p>

	  		<p>Role: {info.role}</p>
   
          <p>Company Name: {info.companyName}</p>
        </div>
      )}
    </div>
  )
}

export default Dashboard